// extracted by mini-css-extract-plugin
export var childrenContent = "bN_fH";
export var content = "bN_L";
export var titleContent = "bN_fJ";
export var titleContentLabel = "bN_fK";